exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "app-player-registration .mygolf-form-error {\n  color: red;\n  font-size: x-small;\n  font-weight: lighter; }\n\napp-player-registration form input[type='text'], app-player-registration form input[type='email'], app-player-registration form input[type='password'] {\n  width: 100%; }\n\napp-player-registration form label {\n  font-size: 1.2rem; }\n\napp-player-registration form .form-item {\n  margin-top: 1rem;\n  margin-bottom: 1rem; }\n\napp-player-registration form .button-panel {\n  margin-top: 1rem;\n  text-align: right; }\n\napp-player-registration .main-container {\n  height: 700px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/bs_work/toMigrate_litePortal/src/app/home-module/player-registration/player-registration.component.scss
// module id = ../../../../../src/app/home-module/player-registration/player-registration.component.scss
// module chunks = main